export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: "up" | "down" | "flat";
  category: string;
}

export interface Article {
  id: number;
  category: string;
  title: string;
  summary: string;
  tag: string;
  reads: string;
  time: string;
  image: string;
  badge?: string;
}

export interface TimelineEvent {
  day: string;
  date: string;
  title: string;
  desc: string;
  heat: string;
}

export interface DeepDive {
  id: number;
  label: string;
  title: string;
  intro: string;
  keywords: string[];
  image: string;
  verified: string;
}

export interface DiscussTopic {
  id: number;
  topic: string;
  replies: number;
  hot: boolean;
  latest: string;
  firstReply: string;
}

export const hotList: HotItem[] = [
  { rank: 1, title: "年度盛典红毯造型盘点：谁赢了镜头？", tag: "综艺", heat: "983万", trend: "up", category: "今日瓜王" },
  { rank: 2, title: "跨年晚会收视战报出炉，几家欢喜几家愁", tag: "综艺", heat: "912万", trend: "up", category: "今日瓜王" },
  { rank: 3, title: "新晋小花片场路透引发热议，是敬业还是炒作？", tag: "影视", heat: "846万", trend: "down", category: "今日瓜王" },
  { rank: 4, title: "音综收官夜爆冷结果，网友直呼意料之外", tag: "音乐", heat: "798万", trend: "up", category: "今日瓜王" },
  { rank: 5, title: "老牌演员翻红后综艺首秀，演技派也搞笑了", tag: "综艺", heat: "752万", trend: "up", category: "今日瓜王" },
  { rank: 6, title: "都市情感剧杀青宴被拍，主创互动成焦点", tag: "影视", heat: "701万", trend: "flat", category: "今日瓜王" },
  { rank: 7, title: "运动员跨界综艺，成绩与娱乐如何平衡", tag: "体育", heat: "654万", trend: "down", category: "今日瓜王" },
  { rank: 8, title: "直播一哥复播首秀，数据背后藏着什么", tag: "主播", heat: "609万", trend: "up", category: "今日瓜王" },
  { rank: 9, title: "热门IP影视化官宣，选角名单引争议", tag: "影视", heat: "562万", trend: "down", category: "今日瓜王" },
  { rank: 10, title: "颁奖礼后专访爆金句，主持人差点接不住", tag: "访谈", heat: "518万", trend: "flat", category: "今日瓜王" },
];

export const categoryTabs: string[] = ["全部瓜", "影视", "综艺", "音乐", "体育", "主播", "社会"];

export const articleFeed: Article[] = [
  {
    id: 1, category: "综艺", tag: "红毯", reads: "12.3万", time: "2小时前", badge: "新",
    title: "年度盛典红毯生图流出，造型团队审美在线",
    summary: "连续多家工作室放出高清生图，从配色到版型细节被逐帧拆解，网友票选本场最佳与最想吐槽造型。",
    image: "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20evening%20gown%20closeup%20of%20coral%20red%20silk%20dress%20fabric%20details%20under%20warm%20golden%20spotlights%2C%20backstage%20celebrity%20style%2C%20soft%20bokeh%20stage%20lights%2C%20editorial%20fashion%20photography&width=800&height=560&seq=gua-2026-010&orientation=landscape",
  },
  {
    id: 2, category: "影视", tag: "选角", reads: "9.8万", time: "3小时前",
    title: "IP大制作选角名单曝光，书粉与路人的交锋",
    summary: "从主角到配角逐一分析是否符合原作人设，评论区吵翻天，片方回应称一切以官宣为准。",
    image: "https://readdy.ai/api/search-image?query=movie%20audition%20casting%20director%20table%20with%20headshots%20scripts%20and%20warm%20desk%20lamp%20in%20dark%20theater%20backstage%2C%20cinematic%20film%20production%20atmosphere%2C%20editorial%20photography&width=800&height=560&seq=gua-2026-011&orientation=landscape",
  },
  {
    id: 3, category: "音乐", tag: "盛典", reads: "7.6万", time: "4小时前",
    title: "音综收官夜：结果爆冷但口碑回暖",
    summary: "冠军归属尘埃落定，然而真正出圈的却是几位遗珠，节目组回应称尊重每一位舞台上的歌手。",
    image: "https://readdy.ai/api/search-image?query=live%20music%20stage%20with%20warm%20golden%20spotlights%20mic%20stand%20and%20confetti%20in%20air%2C%20concert%20finale%20atmosphere%2C%20vibrant%20editorial%20concert%20photography&width=800&height=560&seq=gua-2026-012&orientation=landscape",
  },
  {
    id: 4, category: "体育", tag: "跨界", reads: "6.4万", time: "5小时前",
    title: "冠军运动员上综艺：真性情圈粉无数",
    summary: "一档体验类综艺请来多位退役名将，训练日常笑料百出，也让人看到运动场上之外的另一面。",
    image: "https://readdy.ai/api/search-image?query=athlete%20doing%20fun%20physical%20challenge%20on%20colorful%20game%20show%20set%20with%20warm%20lights%2C%20sporty%20energetic%20vibe%2C%20editorial%20photography&width=800&height=560&seq=gua-2026-013&orientation=landscape",
  },
  {
    id: 5, category: "主播", tag: "直播", reads: "5.9万", time: "6小时前", badge: "爆",
    title: "头部主播回归首播，数据与争议齐飞",
    summary: "时隔多月回归，开播一小时弹幕刷屏，直播间在线人数与实时销量数据被反复截图分析。",
    image: "https://readdy.ai/api/search-image?query=modern%20live%20streaming%20studio%20with%20product%20display%20shelves%20ring%20light%20and%20warm%20backdrop%2C%20ecommerce%20anchor%20return%2C%20editorial%20photography&width=800&height=560&seq=gua-2026-014&orientation=landscape",
  },
  {
    id: 6, category: "影视", tag: "杀青", reads: "5.2万", time: "8小时前",
    title: "都市剧圆满杀青，主创合影走心发言",
    summary: "历经数月拍摄终于杀青，现场主创含泪互cue，导演承诺下一部更精彩，期待值直接拉满。",
    image: "https://readdy.ai/api/search-image?query=film%20crew%20wrap%20party%20with%20clapperboard%20and%20bouquet%20on%20warm%20golden%20hour%20set%2C%20celebration%20atmosphere%2C%20editorial%20photography&width=800&height=560&seq=gua-2026-015&orientation=landscape",
  },
  {
    id: 7, category: "综艺", tag: "收视", reads: "4.7万", time: "10小时前",
    title: "跨年晚会收视出炉：创新编排成最大赢家",
    summary: "平台公布收视战报，别出心裁的舞台设计收获好评，但也有人质疑数据口径，讨论仍在发酵。",
    image: "https://readdy.ai/api/search-image?query=grand%20new%20year%20galas%20television%20stage%20with%20warm%20colorful%20lights%20and%20large%20screens%2C%20festive%20celebration%2C%20editorial%20photography&width=800&height=560&seq=gua-2026-016&orientation=landscape",
  },
  {
    id: 8, category: "社会", tag: "热点", reads: "4.1万", time: "12小时前",
    title: "街头快闪合唱意外走红，平凡人的高光时刻",
    summary: "一段普通路人合唱视频冲上热搜，没有专业包装却打动无数人，评论区满是温暖留言。",
    image: "https://readdy.ai/api/search-image?query=group%20of%20people%20singing%20together%20outdoors%20at%20golden%20hour%20in%20city%20plaza%2C%20warm%20street%20crowd%20joyful%20moment%2C%20documentary%20editorial%20photography&width=800&height=560&seq=gua-2026-017&orientation=landscape",
  },
];

export const weekTimeline: TimelineEvent[] = [
  {
    day: "周一", date: "10.21", heat: "热搜第2",
    title: "红毯盛典掀开幕季热潮，造型话题霸榜一整晚",
    desc: "从主咖到新人集体发力，当晚微博热搜前十里红毯相关占了五席，成为本周话题起点。",
  },
  {
    day: "周二", date: "10.22", heat: "热搜第4",
    title: "IP影视化官宣，选角讨论冲上榜单前列",
    desc: "片方一纸官宣引发书粉与路人激烈讨论，原作粉摆出的人设对照表广为流传。",
  },
  {
    day: "周三", date: "10.23", heat: "热搜第1",
    title: "音综收官夜爆冷，冠军之外的歌单杀疯了",
    desc: "结果虽有争议，但多首现场翻唱登顶音乐榜，被网友称为耳朵的胜利。",
  },
  {
    day: "周四", date: "10.24", heat: "热搜第3",
    title: "运动员综艺首秀，反差萌成功破圈",
    desc: "真性情与高情商齐上阵，训练场的硬核与综艺场的搞笑形成反差，圈粉无数路人。",
  },
  {
    day: "周五", date: "10.25", heat: "热搜第5",
    title: "都市剧杀青，主创一条走心微博刷屏",
    desc: "长达数月的剧组生活画上句号，导演与主演的告别长文被大量转载，期待感拉满。",
  },
];

export const deepDives: DeepDive[] = [
  {
    id: 1, label: "深扒调查", title: "热搜第三的真相：一场被误读的片场故事", verified: "多方交叉核实",
    keywords: ["片场", "误读", "真相"],
    intro: "最初流传的片段经过剪辑拼接，配上情绪化标题迅速发酵。我们回看完整素材、比对时间线后发现，所谓冲突实为剧本排练中一次正常的临场发挥。",
    image: "https://readdy.ai/api/search-image?query=magnifying%20glass%20over%20cluttered%20newspaper%20clippings%20and%20video%20timeline%20strips%20on%20desk%2C%20investigative%20journalism%20warm%20desk%20lamp%2C%20editorial%20concept&width=640&height=640&seq=gua-2026-020&orientation=squarish",
  },
  {
    id: 2, label: "背后故事", title: "爆红的那首歌，背后是三个月的无人问津", verified: "内部人士确认",
    keywords: ["爆红", "创作", "坚持"],
    intro: "当打之年没人听的demo，却在某档节目里一鸣惊人。创作者坦言曾想过放弃，把故事讲清楚，比单纯的一夜爆红更有看头。",
    image: "https://readdy.ai/api/search-image?query=handwritten%20sheet%20music%20and%20vintage%20studio%20equipment%20warm%20light%2C%20songwriter%20desk%20with%20headphones%2C%20editorial%20storytelling&width=640&height=640&seq=gua-2026-021&orientation=squarish",
  },
  {
    id: 3, label: "营销号没敢说", title: "别被标题带节奏：拆解热搜的完整时间线", verified: "时间线还原",
    keywords: ["热搜", "时间线", "还原"],
    intro: "消息从无中生有到辟谣、再反转，短短一天内剧情跌宕。我们把每一份声明、每一次回应按分钟还原，营销号最爱的爆点其实只是故事的一半。",
    image: "https://readdy.ai/api/search-image?query=torn%20newspaper%20headlines%20and%20red%20pencil%20marks%20correcting%20false%20claims%20on%20warm%20desk%2C%20fact%20checking%20concept%2C%20editorial%20photography&width=640&height=640&seq=gua-2026-022&orientation=squarish",
  },
  {
    id: 4, label: "数据解读", title: "直播数据暴涨背后：真实的粉丝与机器的痕迹", verified: "第三方监测",
    keywords: ["直播", "数据", "真实"],
    intro: "同场直播在线人数波动剧烈，第三方监测显示部分峰值来自异常流量。数据会说话，我们教你识别哪些是热度、哪些是水分。",
    image: "https://readdy.ai/api/search-image?query=analytics%20dashboard%20screens%20with%20rising%20charts%20and%20red%20annotation%20markers%20on%20warm%20workspace%2C%20data%20journalism%20concept%2C%20editorial&width=640&height=640&seq=gua-2026-023&orientation=squarish",
  },
];

export const discussTopics: DiscussTopic[] = [
  {
    id: 1, hot: true, replies: 1843, topic: "红毯造型谁赢了？说说你心里的最佳造型",
    latest: "阿梨很忙", firstReply: "那套珊瑚色高定真的是今晚最佳，从颜色到版型都没得挑！",
  },
  {
    id: 2, hot: true, replies: 1266, topic: "音综冠军之外的遗珠，你最遗憾谁？",
    latest: "一颗橙子", firstReply: "那个唱慢歌的弟弟被低估了，我单曲循环了一晚上。",
  },
  {
    id: 3, hot: false, replies: 958, topic: "IP选角名单出来了，你心里的最佳人选是谁？",
    latest: "纸鸢", firstReply: "男女主都还行，配角简直神仙打架，蹲一个正式官宣。",
  },
  {
    id: 4, hot: false, replies: 742, topic: "直播数据那么多水，你们还信谁家销量？",
    latest: "路人甲本甲", firstReply: "看第三方监测比较靠谱，谁的钱都不是大风刮来的。",
  },
  {
    id: 5, hot: false, replies: 531, topic: "运动员上综艺到底算不算不务正业？",
    latest: "起跑线", firstReply: "退役后转型很正常啊，能传播体育精神是好事。",
  },
];

export const faqs: { q: string; a: string }[] = [
  {
    q: "每日吃瓜的瓜源从哪里来？",
    a: "我们整合了公开的热搜、各平台热点与经交叉核实的多方信息，由编辑团队人工筛选后整理成栏目。所有内容都尽量标注来源与时间线，帮助大家理性吃瓜。",
  },
  {
    q: "热搜背后的故事栏目和其他八卦号有什么不同？",
    a: "我们不追单一爆点，而是回溯事件完整过程：谁先说、证据链如何、辟谣是否成立。用时间线与多方信源还原真相，避免被标题带节奏。",
  },
  {
    q: "看到疑似谣言的热搜，我该怎么判断真假？",
    a: "建议先看是否有官方或当事人声明，再比对不同平台的报道时间线。若只有单一来源且措辞情绪化，大概率在带节奏，可到我们营销号没敢说的栏目对照。",
  },
  {
    q: "营销号没敢说的栏目，是怎么做核实的？",
    a: "每篇内容都基于公开记录、当事人回应及多位独立信源进行交叉验证，无法确认的部分会明确标注待核实，绝不为了流量编造细节。",
  },
  {
    q: "我也想发帖聊聊我看到的瓜，可以投稿吗？",
    a: "可以！在瓜友讨论区参与话题即可。若你掌握独家的完整事实链，欢迎通过页面底部订阅与联系入口告诉我们，编辑会评估后处理。",
  },
  {
    q: "更新频率是怎样的？",
    a: "我们每日更新今日瓜田汇总，每周推出大事件盘点，热搜背后故事与深扒内容则按热点发酵情况即时跟进，保证时效性。",
  },
];

export const trendingTicker: string[] = [
  "年度红毯造型盘点刷屏",
  "音综收官夜歌单杀疯了",
  "IP选角名单引争议",
  "主播回归首播数据解析",
  "运动员综艺反差萌破圈",
  "热搜第三的真相还原",
  "跨年晚会收视战报",
];